<template>
  <div v-if="fields.length">
    <action-alert :type="alert.type" :icon="alert.icon" :is-visible="alert.isVisible">{{alert.text}}</action-alert>
    <SavedSearches :years-object="yearsObject" :apply="applyQuery" :remove="removeSavedQuery" ref="savedSearches"></SavedSearches>
    <div class="container-fluid">
      <DiagnosticsPopup v-if="Object.keys(analytics).length && showDiagnostics" class="diagnostics"
                        :class="{'sidebard-toggled': isSidebarToggled}" :toggle-diagnostics="toggleDiagnostics"
                        :data="analytics.errorlog"></DiagnosticsPopup>
      <Breadcrumb :values="{ Home: '/', 'Analytics': '' }"></Breadcrumb>
      <div class="animated" :class="{fadeIn: triggerFadeIn}">
        <div>
          <SearchFilters :fields="fields" :analytics-fields="analyticsFields" :searchData="searchData" :hideTabs="hideTabs"
                         :parseData="searchFunctions.parseDataForSearch" :switchTabs="switchTabs" @setCollapse="val => filtersVisible = val"
                         :saveFilters="saveQuery" :saveMessage="saveMessage" @update:saveMessage="saveMessage = $event"
                         @update:yearsObject="yearsObject = $event"
                         :toggle-diagnostics="toggleDiagnostics" :resetDropdowns="resetDropdownValues"
                         ref="filters" :resetAnalyticsTabs="resetAnalyticsTabs" :header="$route.params.header" :toggleSavedSearches="toggleSavedSearches"
                         :showSavedSearches="showSavedSearches" :update-dropdown-values="updateDropdownValues" :collapsed="filtersVisible"
                         :yearsObject="yearsObject"></SearchFilters>
        </div>
        <div class="animated fadeIn">
          <div class="col-12 px-0 mb-4" style="margin-top: 39px" v-if="showTabs">
            <AnalyticsTabs :switch-tabs="switchTabs" :active-tab="activeTab" :collapsed="filtersVisible"
                           :filter-fields="analyticsFields" :fields="fields" :searchData="searchData"
                           :download="downloadXLSXFile" :search-type="lastSearchType"
                           :parseData="searchFunctions.parseDataForSearch" :is-genisys="isGenisys" ref="analytics"></AnalyticsTabs>
            <div class="footnote">
              <span class="footnote-text">All scores and metrics have been harmonized to a common 5 point scale</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import Breadcrumb from '../components/shared/Breadcrumb'
import generalActions from '../store/modules/general/actionTypes'
import SavedSearches from '../components/Search/SavedSearches'
import SearchFilters from '../components/Search/SearchFilters'
import studiesActions from '../store/modules/studies/actionTypes'
import studiesGetters from '../store/modules/studies/getterTypes'
import ActionAlert from '../components/shared/ActionAlert'
import DiagnosticsPopup from '../components/Search/DiagnosticsPopup'
import generalGetters from '../store/modules/general/getterTypes'
import AnalyticsTabs from '../components/Search/AnalyticsTabs'
import searchFunctions from '../helpers/searchFunctions'
import fileNames from '../constants/fileNames'
import searchFilters from '../constants/searchFilters'
import yearBounds from '../helpers/yearBounds'

export default {
  name: 'Search2',
  components: {
    AnalyticsTabs,
    DiagnosticsPopup,
    ActionAlert,
    SearchFilters,
    Breadcrumb,
    SavedSearches
  },
  data () {
    return {
      fields: [],
      analyticsFields: [],
      activeTab: '',
      ready: true,
      saveMessage: {
        error: false,
        value: ''
      },
      alert: {
        type: '',
        icon: '',
        text: '',
        isVisible: false
      },
      intervals: {
        metrics: null,
        attributes: null,
        performance: null,
        default: null
      },
      yearsObject: null,
      lastSearchType: '',
      showTabs: false,
      showDiagnostics: false,
      showSavedSearches: false,
      triggerFadeIn: true,
      filtersVisible: true,
      searchFunctions,
      isGenisys: false
    }
  },
  computed: {
    ...mapGetters({
      filterValues: studiesGetters.GET_SEARCH_FILTERS,
      metricsJobId: studiesGetters.GET_METRICS_JOB_ID,
      performanceJobId: studiesGetters.GET_PERFORMANCE_JOB_ID,
      tendenciesJobId: studiesGetters.GET_TENDENCIES_JOB_ID,
      attributesJobId: studiesGetters.GET_ATTRIBUTES_JOB_ID,
      analytics: studiesGetters.GET_ANALYTICS,
      saved_searches: studiesGetters.GET_SAVED_SEARCHES,
      isSidebarToggled: generalGetters.GET_SIDEBAR_STATE
    }),
    savedSearches () {
      return this.saved_searches
    },
    isReady () {
      return !this.ready
    }
  },
  methods: {
    ...mapActions({
      applySearch: studiesActions.APPLY_SEARCH_FILTERS,
      deleteSearch: studiesActions.DELETE_SAVED_SEARCH,
      queueMetricSearch: studiesActions.QUEUE_METRIC_SEARCH,
      queueAttributesSearch: studiesActions.QUEUE_ATTRIBUTES_SEARCH,
      queuePerformanceSearch: studiesActions.QUEUE_PERFORMANCE_SEARCH,
      queueTendenciesSearch: studiesActions.QUEUE_TENDENCIES_SEARCH,
      getAnalyticsFields: studiesActions.FETCH_ANALYTICS_FIELDS,
      getMetrics: studiesActions.CHECK_METRIC_JOB_STATUS,
      getAttributes: studiesActions.CHECK_ATTRIBUTES_JOB_STATUS,
      getPerformance: studiesActions.CHECK_PERFORMANCE_JOB_STATUS,
      getXlsxMetrics: studiesActions.CHECK_METRIC_XLSX_JOB_STATUS,
      getXlsxAttributes: studiesActions.CHECK_ATTRIBUTES_XLSX_JOB_STATUS,
      getXlsxPerformance: studiesActions.CHECK_PERFORMANCE_XLSX_JOB_STATUS,
      getTendencies: studiesActions.FETCH_TENDENCIES,
      getUpdatedDropdownValues: studiesActions.UPDATE_DROPDOWN_OPTIONS,
      getUpdatedMetricsDropdownValues: studiesActions.UPDATE_METRICS_DROPDOWN_OPTIONS,
      getSavedSearches: studiesActions.FETCH_SAVED_SEARCHES,
      getStudiesCount: studiesActions.FETCH_STUDIES_COUNT,
      saveSearch: studiesActions.POST_SAVED_SEARCH,
      toggleLoading: generalActions.TOGGLE_LOADING
    }),
    async updateDropdownValues (values) {
      if (values) {
        const data = this.searchFunctions.parseDataForSearch(values, true)
        const res = await this.getUpdatedMetricsDropdownValues({ query: data.query, queryMetrics: data.metrics, rdfType: values.metrics.useConcepts ? 'concepts' : 'fragrances', irtImplict: values.metrics.rdfType })
        this.fields = res.data.fields
        const metricData = res.data.fields.find(el => el.group_label === 'analytics')
        this.analyticsFields = metricData.data
      }
    },
    async searchData (parsedData, additionalData, dataType) {
      const rdfType = parsedData.responses.find(el => el.field === 'rdf_type')
      this.isGenisys = rdfType.filter.value === 'eeg'
      this.lastSearchType = this.filterValues.metrics.useConcepts ? 'concepts' : 'fragrances'
      this.showTabs = true
      setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 1000)
      let frags = []
      if (['performance', 'attributes', 'tendencies'].includes(dataType)) {
        frags = this.mapFragrance()
      }
      switch (dataType) {
        case 'metrics':
          try {
            await this.queueMetricSearch({ q: parsedData, noCache: this.$route.query.no_cache })
            this.intervals.metrics = setInterval(async () => {
              const data = await this.getMetrics(this.metricsJobId)
              if (data) {
                clearInterval(this.intervals.metrics)
                this.$refs.analytics.ready.metrics = true
              }
            }, 3000)
          } catch (e) {
            console.log(e)
            this.$refs.analytics.ready.metrics = true
          }
          break
        case 'performance':
          try {
            await this.queuePerformanceSearch({ q: parsedData, data: additionalData, frags, noCache: this.$route.query.no_cache })
            this.intervals.performance = setInterval(async () => {
              const data = await this.getPerformance(this.performanceJobId)
              if (data) {
                clearInterval(this.intervals.performance)
                this.$refs.analytics.ready.performance = true
              }
            }, 3000)
          } catch (e) {
            console.log(e)
            this.$refs.analytics.ready.performance = true
          }
          break
        case 'attributes':
          try {
            await this.queueAttributesSearch({ q: parsedData, data: additionalData, frags, noCache: this.$route.query.no_cache })
            this.intervals.attributes = setInterval(async () => {
              const data = await this.getAttributes(this.attributesJobId)
              if (data) {
                this.$refs.analytics.ready.attributes = true
                clearInterval(this.intervals.attributes)
              }
            }, 3000)
          } catch (e) {
            console.log(e)
            this.$refs.analytics.ready.attributes = true
          }
          break
        case 'tendencies':
          try {
            const data = await this.getTendencies({ q: parsedData, data: additionalData, frags })
            if (data) {
              this.ready = true
              this.$refs.analytics.ready.tendencies = true
            }
          } catch (e) {
            this.ready = true
            console.log(e)
            this.$refs.analytics.ready.tendencies = true
          }
          break
        default:
          try {
            await this.queueMetricSearch(parsedData)
            this.intervals.default = setInterval(async () => {
              const data = await this.getMetrics(this.metricsJobId)
              if (data) {
                clearInterval(this.intervals.default)
              }
            }, 3000)
          } catch (e) {
            console.log(e)
          }
          break
      }
    },
    async downloadXLSXFile (dataType, filters = [], metricThreshold = null) {
      let response
      let filename
      switch (dataType) {
        case 'metrics':
          response = await this.getXlsxMetrics({ jobId: this.metricsJobId, filters: filters, metricThreshold })
          filename = fileNames.analyticsMetrics
          break
        case 'performance':
          response = await this.getXlsxPerformance(this.performanceJobId)
          filename = fileNames.analyticsPerformance
          break
        case 'attributes':
          response = await this.getXlsxAttributes(this.attributesJobId)
          filename = fileNames.analyticsTopAttributes
          break
        default:
          response = await this.getXlsxMetrics(this.metricsJobId)
          filename = fileNames.analyticsMetrics
          break
      }
      if (response) {
        try {
          const url = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        } catch {}
      }
    },
    async switchTabs (tab) {
      this.activeTab = tab
    },
    async resetAnalyticsTabs () {
      setTimeout(() => {
        const ref = this.$refs['analytics']
        ref.resetTabs()
      }, 500)
    },
    shouldSaveQuery (data) {
      const isEmpty = (obj) => { return Object.keys(obj).length === 0 }
      let saveFlag = false
      Object.keys(data).forEach(category => {
        Object.keys(data[category]).forEach(field => {
          if (field === 'threshold') {
            const { applyThreshold, type } = data[category][field]
            if (!applyThreshold || (applyThreshold && type)) {
              saveFlag = true
            }
          } else if (field === 'metricsList') {
            data[category][field].forEach(value => {
              const nonEmptyData = Object.keys(value).filter(el => {
                if (typeof value[el] === 'object') {
                  return value[el].value.length
                } else {
                  return value[el]
                }
              })
              if (nonEmptyData.length) {
                saveFlag = true
              }
            })
          } else {
            if (!isEmpty(data[category][field]) && data[category][field].value) {
              saveFlag = true
            }
          }
        })
      })
      return saveFlag
    },
    async resetDropdownValues () {
      const res = await this.getUpdatedMetricsDropdownValues({ query: [], query_metrics: [] })
      this.fields = res.data.fields
      const metricData = res.data.fields.find(el => el.group_label === 'analytics')
      this.analyticsFields = metricData.data
    },
    async resetComponentState () {
      this.toggleLoading(true)
      this.activeTab = 'metrics'
      if (!this.totalStudiesCount) {
        await this.getStudiesCount()
      }
      await this.getSavedSearches({
        userId: this.$auth.user().id,
        type: 'analytics'
      })
      await this.resetDropdownValues()
      this.showTabs = false
      this.showDiagnostics = false
      this.toggleLoading(false)
      if (this.$route.params.startSearch) {
        this.$refs.filters.search()
        const scrollElement = document.querySelector('.app-body')
        setTimeout(() => {
          scrollElement.scrollTo(0, scrollElement.scrollHeight)
          this.filtersVisible = false
        }, 50)
      }
    },
    hideTabs () {
      this.showTabs = false
    },
    toggleAlert (type, icon, text) {
      this.alert = {
        type,
        icon,
        text,
        isVisible: true
      }
      setTimeout(() => this.alert.isVisible = false, 3000)
    },
    applyQuery (search) {
      // Rehydrates the compact payload; a no-op for pre-existing saved searches.
      const parsedFilters = searchFilters.expandSavedQuery(JSON.parse(search.metadata_query))
      this.applySearch(parsedFilters)
      this.$refs.filters.refreshFilters(true)
      const yearObject = [
        parsedFilters.essentials.startYear ? parsedFilters.essentials.startYear.value : null,
        parsedFilters.essentials.endYear ? parsedFilters.essentials.endYear.value : null
      ]
      this.$refs.filters.applyYears(yearObject)
      if (parsedFilters.demographics.socialClass) {
        const socialClass = this.analyticsFields.demographics.social_class.find(el =>
          JSON.stringify(el.value) === JSON.stringify(parsedFilters.demographics.socialClass.value)
        )
        this.$refs.filters.applySocialClass(socialClass.label)
      }
    },
    toggleDiagnostics () {
      this.showDiagnostics = !this.showDiagnostics
    },
    toggleSavedSearches () {
      this.$refs.savedSearches.toggle()
      this.showSavedSearches = !this.showSavedSearches
    },
    async saveQuery (name, data) {
      const filters = { ...data }
      if (this.shouldSaveQuery(filters)) {
        const parsedData = _.cloneDeep(filters)
        Object.keys(parsedData).forEach(category => {
          Object.keys(parsedData[category]).forEach(key => {
            let fieldData = parsedData[category][key]
            if (typeof fieldData.applyThreshold === 'boolean') {
              return !fieldData.applyThreshold && delete parsedData[category][key]
            } else if (Array.isArray(fieldData)) {
              fieldData.forEach(metric => {
                const applyThreshold = metric.applyThreshold
                Object.keys(metric).forEach(metricKey => {
                  if (metricKey === 'threshold') {
                    return !applyThreshold && delete metric[metricKey]
                  } else {
                    const isArray = Array.isArray(metric[metricKey].value)
                    const isEmpty = isArray ? !!metric[metricKey].value.length : !!metric[metricKey].value
                    return !isEmpty && delete metric[metricKey]
                  }
                })
              })
              parsedData[category][key] = fieldData.filter(value => Object.keys(value).length !== 0)
            } else {
              const isArray = Array.isArray(fieldData.value)
              const isEmpty = isArray ? !!fieldData.value.length : !!fieldData.value
              return !isEmpty && delete parsedData[category][key]
            }
          })
        })
        const metadataQuery = JSON.stringify(searchFilters.compactSavedQuery(parsedData))
        if (searchFilters.isSavedQueryTooLarge(metadataQuery)) {
          this.saveMessage.error = true
          this.saveMessage.value = searchFilters.SAVED_QUERY_TOO_LARGE_MESSAGE
          return false
        }
        let data = {
          metadata_query: metadataQuery,
          slug: name || `Search ${this.saved_searches.length + 1}`
        }
        let response = null
        try {
          response = await this.saveSearch({
            userId: this.$auth.user().id,
            data,
            type: 'analytics'
          })
          if (response.status === 200) {
            this.$refs.savedSearches.toggleBlink()
            this.toggleAlert('success', 'check-circle', `Successfully saved current search as "${data.slug}".`)
            this.saveMessage.error = false
            this.saveMessage.value = ''
            this.$refs.filters.clearName()
            return true
          }
        } catch (e) {
          this.saveMessage.error = true
          this.saveMessage.value = e.response.data.message
          return false
        }
      } else {
        this.saveMessage.error = true
        this.saveMessage.value = 'You can\'t save searches with empty filters!'
        return false
      }
    },
    async removeSavedQuery (searchId) {
      await this.deleteSearch({
        userId: this.$auth.user().id,
        data: { searchId },
        type: 'analytics'
      })
    },
    mapFragrance () {
      return this.$refs.analytics.metrics.results.map(el => {
        return {
          'id': el.id,
          'c_mi_number': el.c_mi_number,
          'prod': el.prod
        }
      })
    },
    setYearSliderBounds () {
      const yearGroup = this.fields?.find(group => group.group_label === 'metadata') || this.fields?.[0]
      const yearField = yearGroup?.data?.find(field => ['year', 'Year'].includes(field.field || field.label))
      const yearValues = yearField?.options
        ?.map(option => parseInt(option.value, 10))
        .filter(year => !Number.isNaN(year))
        .sort((a, b) => a - b)
      if (!yearValues?.length) {
        return
      }
      const firstYear = yearValues[0]
      const lastYear = Math.max(yearValues[yearValues.length - 1], 2025)
      // Narrowing the bounds must not discard the range the user picked - it
      // stays in the query either way, so resetting the slider left the two
      // showing different things.
      const value = yearBounds.resolveYearSelection({
        previous: this.yearsObject?.value,
        previousBounds: this.yearsObject
          ? [this.yearsObject.min, this.yearsObject.max]
          : null,
        min: firstYear,
        max: lastYear
      })
      this.yearsObject = {
        min: firstYear,
        max: lastYear,
        marks: { [firstYear]: String(firstYear), [lastYear]: String(lastYear) },
        value
      }
    }
  },
  async mounted () {
    await this.resetComponentState()
  },
  async beforeRouteLeave (to, from, next) {
    Object.keys(this.intervals).forEach(key => {
      if (this.intervals[key]) {
        clearInterval(this.intervals[key])
      }
    })
    if (this.$refs.filters.areFiltersEmpty || to.name === 'login') {
      await this.$refs.filters.resetFilters()
      next()
    } else if (!to.query.allowLocationChange) {
      this.$refs.filters.togglePopup(to.name)
      next(false)
    } else {
      if (to.name !== 'analytics') {
        await this.$refs.filters.resetFilters()
      }
      next()
    }
  },
  watch: {
    '$route': async function (newPath) {
      this.triggerFadeIn = false
      setTimeout(() => this.triggerFadeIn = true, 0)
      if (['search', 'analytics'].includes(newPath.name)) {
        await this.resetComponentState()
      }
    },
    fields () {
      this.setYearSliderBounds()
    }
  }
}
</script>

<style>
.nav-link {
  margin-bottom: 0;
}

.el-table::before {
  height: 0 !important;
}

.search-filter {
  width: 100%;
  padding: 10px 20px;
  border-bottom: 1px solid #d1d4d7;
}

.search-filter:last-of-type {
  border-bottom: unset;
}

.tab-pane {
  overflow: scroll;
  position: relative;
}

.saved-searches-header {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.el-checkbox__label {
  color: #20a8d8 !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #20a8d8 !important;
  background-color: #20a8d8 !important;
}

.no-overflow {
  overflow: unset !important;
}

.diagnostics {
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  z-index: 1003;
  transition: width 0.2s linear;
}

.sidebard-toggled {
  width: calc(100% - 250px);
}

.footnote {
  margin-top: 5px;
  height: 24px;
}

.footnote-text {
  float: right;
  color: #959799;
  font-size: 16px;
  margin-right: 20px;
}

.description-header {
  color: #959799;
}

.container-fluid {
  padding: 0 !important;
}
</style>
